export class LoginActionParameter {}
export var AccessActions;
(function (AccessActions) {
  // client app does not know if it has a session cookie, so StartSession is a blind guess.
  let StartSession = /*#__PURE__*/(() => {
    class StartSession {
      static {
        this.type = '[Access] StartSession';
      }
      constructor() {}
    }
    return StartSession;
  })();
  AccessActions.StartSession = StartSession;
  let RefreshSession = /*#__PURE__*/(() => {
    class RefreshSession {
      static {
        this.type = '[Access] RefreshSession';
      }
      constructor() {}
    }
    return RefreshSession;
  })();
  AccessActions.RefreshSession = RefreshSession;
  let Logout = /*#__PURE__*/(() => {
    class Logout {
      static {
        this.type = '[Access] Logout';
      }
      constructor() {}
    }
    return Logout;
  })();
  AccessActions.Logout = Logout;
  let SetReferrerCode = /*#__PURE__*/(() => {
    class SetReferrerCode {
      static {
        this.type = '[Access] SetReferrerCode';
      }
      constructor(referrerCode) {
        this.referrerCode = referrerCode;
      }
    }
    return SetReferrerCode;
  })();
  AccessActions.SetReferrerCode = SetReferrerCode;
  let AddAuthCodes = /*#__PURE__*/(() => {
    class AddAuthCodes {
      static {
        this.type = '[Access] AddAuthCodes';
      }
      constructor(authCodes, deleteOthers = false) {
        this.authCodes = authCodes;
        this.deleteOthers = deleteOthers;
      }
    }
    return AddAuthCodes;
  })();
  AccessActions.AddAuthCodes = AddAuthCodes;
  let RemoveAuthCode = /*#__PURE__*/(() => {
    class RemoveAuthCode {
      static {
        this.type = '[Access] RemoveAuthCode';
      }
      constructor(authCode) {
        this.authCode = authCode;
      }
    }
    return RemoveAuthCode;
  })();
  AccessActions.RemoveAuthCode = RemoveAuthCode;
  let SuppressIsReady = /*#__PURE__*/(() => {
    class SuppressIsReady {
      static {
        this.type = '[Access] SuppressIsReady';
      }
      constructor() {}
    }
    return SuppressIsReady;
  })();
  AccessActions.SuppressIsReady = SuppressIsReady;
})(AccessActions || (AccessActions = {}));
// export UserActions;